import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import MyAccountScreen from '../screens/account/MyAccountScreen';
import InvoiceDetailScreen from '../screens/account/InvoiceDetailScreen';
import BulkRenewalScreen from '../screens/subscription/BulkRenewalScreen';

const Stack = createNativeStackNavigator();

const AccountNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="MyAccountMain" component={MyAccountScreen} />
      <Stack.Screen name="InvoiceDetail" component={InvoiceDetailScreen} />
      <Stack.Screen name="BulkRenewal" component={BulkRenewalScreen} />
    </Stack.Navigator>
  );
};

export default AccountNavigator;
